import React, { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Warning from "./Warning";
import parkingProductsActions from "../../store/actions/parkingProducts.actions";
import useFleetManagerContext from "../../context/hooks/useFleetManagerContext";
import useAppContext from "../../context/hooks/useAppContext";
import { RootReducer } from "../../store/reducers";
import { RevokeVehicleAssignmentsModel } from "../../models/vehicle-assignments/RevokeVehicleAssignmentsModel";
import { VehicleAssignmentProduct } from "../../models/vehicle-assignments/VehicleAssignmentProduct";
import {parseDVARowKey } from "../../helpers/vehicleAssignment.utils";

interface IFormProps extends StateProps, DispatchProps {
  onRefresh: (vehiclesToExclude?: VehicleAssignmentProduct[]) => void;
}

const RevokeVehicleAssignmentWarning = ({
  parkingProducts,
  revokeVehicleAssignmentsParkingRights,
  onRefresh,
}: IFormProps) => {
  const { t } = useTranslation(["revokeVehicleAssignmentWarning", "globals"]);
  const { toggleRevokeVehicleAssignmentsWarning, fleetManagerState } = useFleetManagerContext();
  const { appState } = useAppContext();
  const selectedVehicleAssignment = fleetManagerState.selectedVehicleAssignment;
  const revokeCount = selectedVehicleAssignment?.rowKey
    ? parseDVARowKey(selectedVehicleAssignment.rowKey).pmcIds.length
    : 0;

  const handleRevokeCancellation = () => {
    toggleRevokeVehicleAssignmentsWarning();
  };

  const handleSuccessfulRevoke = (model: VehicleAssignmentProduct[]) => {
    toggleRevokeVehicleAssignmentsWarning();

    onRefresh(model);
  };

  const handleRevokeConfirmation = () => {
    if (!fleetManagerState.showRevokeParkingVehicleAssignment || !selectedVehicleAssignment?.rowKey) {
      return;
    }

    const parsedKey = parseDVARowKey(selectedVehicleAssignment.rowKey);
    const model: RevokeVehicleAssignmentsModel = {
      seasonTicketOwnerCrmId: appState.user.seasonTicketOwnerCrmId!,
      vehicleAssignmentProducts: parsedKey.pmcIds.map(pmcId => { return  { pmcId: pmcId, vehicleAssignmentId: parsedKey.vehicleAssignmentId }}),
    };
    revokeVehicleAssignmentsParkingRights(model, () =>
      handleSuccessfulRevoke(model.vehicleAssignmentProducts)
    );
  };

  return (
    <Warning
      warning={t("warning", { count: revokeCount })}
      details={t("details", { count: revokeCount })}
      onCancel={handleRevokeCancellation}
      onConfirm={handleRevokeConfirmation}
      disabled={false}
      confirmText={t("globals:revoke")}
      loading={parkingProducts.loading}
    />
  );
};

const mapStateToProps = (state: RootReducer) => {
  const { parkingProducts } = state;

  return {
    parkingProducts,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  revokeVehicleAssignmentsParkingRights: (
    model: RevokeVehicleAssignmentsModel,
    callback: (vehiclesToExclude?: VehicleAssignmentProduct[]) => void
  ) =>
    dispatch(
      parkingProductsActions.revokeVehicleAssignmentProducts(model, () =>
        callback(model.vehicleAssignmentProducts)
      )
    ),
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(RevokeVehicleAssignmentWarning);
